<template>
    <details class="team-activity-group">
        <summary class="team-activity-group__summary">
            <span class="team-timeline__time"><span class="team-activity-group__arrow" aria-hidden="true">▸</span> {{ clockTime(group.inizio) }}–{{ clockTime(group.fine) }}</span>
            <span><strong>{{ activityGroupLabel(group, byId) }}</strong><span class="mc-caption team-activity-group__hint">Ordini, fasi e tempi</span></span>
            <strong class="team-timeline__duration">{{ duration(group.minuti) }}</strong>
        </summary>
        <ol class="team-activity-group__details" aria-label="Dettaglio delle attività del blocco">
            <li v-for="(segment, i) in group.details" :key="i">
                <span class="team-timeline__time">{{ clockTime(segment.inizio) }}–{{ clockTime(segment.fine) }}</span>
                <div>
                    <div v-for="id in segment.attivita_ids" :key="id">{{ activityLabel(byId[id]) }}</div>
                    <span v-if="segment.includesShortIntervals" class="mc-caption">Comprende intervalli brevi fino a 5 minuti</span>
                    <span v-else-if="!segment.attivita_ids.length" class="mc-caption">Intervallo fino a 5 minuti incluso nell’attività</span>
                </div>
                <strong class="team-timeline__duration">{{ duration(segment.minuti) }}</strong>
            </li>
        </ol>
    </details>
</template>
<script>
import { timeDuration as duration } from "./duration-model.mjs";
import { activityLabel, clockTime } from "./day-model.mjs";
import { activityGroupLabel } from "./timeline-model.mjs";
export default {
    name: "TeamActivityGroup",
    props: { group: { type: Object, required: true }, byId: { type: Object, required: true } },
    methods: { duration, activityLabel, clockTime, activityGroupLabel },
};
</script>
